enum InteractionType {
    Email = 1,
    Chat = 2,
    Call = 3,
}

export default InteractionType;
